/** @file A free name for a new entity of a kind: `base`, else `base-2`, `base-3`… (format slugifyName). */
import { ENTITY_KINDS } from '@pose2d/format/doc/entityKinds';
import { slugifyName } from '@pose2d/format/slugifyName';
import type { Doc, EntityKind } from '@pose2d/format/types';

/** Unique among the names of `kind` in `doc`, at most 64 characters. */
export function freeName(doc: Doc, kind: EntityKind, base: string): string {
  const table = doc[ENTITY_KINDS[kind]] as Readonly<Record<string, { name: string }>>;
  return slugifyName(base, new Set(Object.values(table).map((e) => e.name)), 1).name;
}
